import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import hexToRgba from 'hex-to-rgba'

import ScaleModel, { NULL as ScaleModelNULL } from './model'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import { BLOCK_TYPES, FIELD_TYPES } from '@client/components/Block/constants'
import { getValueOrDefaultText } from '@client/utils/getValueOrDefault'
import { defaultText } from './constants'

import inlineStyles from './inlineStyles'

import './styles.scss'

const options = Array(10).fill(0)

export const Scale = ({
  model = ScaleModelNULL,
  editor = EditorModelNULL,
  app = AppModelNULL
}) => {
  const globalSettings = editor.settings.values
  const settings = model.settings.values
  const isRequired = settings.isRequired || false
  const question = getValueOrDefaultText(
    settings.question,
    defaultText.question
  )
  const startLabel = getValueOrDefaultText(
    settings.startLabel,
    defaultText.startLabel
  )
  const endLabel = getValueOrDefaultText(
    settings.endLabel,
    defaultText.endLabel
  )
  return (
    <div
      data-type={BLOCK_TYPES.FIELD}
      data-field-type={FIELD_TYPES.SHORT_TEXT}
      className={`gan-field ${isRequired ? 'gan-field-required' : ''}`}
    >
      <label
        style={{
          ...inlineStyles.label,
          color: globalSettings.normalText_color,
          fontFamily: globalSettings.normalText_fontFamily,
        }}
      >
        {question}
      </label>
      <div className="scale-group">
        {options.map((_, index) => {
          const value = index + 1
          return (
            <label
              className="scale"
              htmlFor={`id_${model.inputName}-${value}`}
              key={index}
            >
              <input
                type="radio"
                name={model.inputName}
                id={`id_${model.inputName}-${value}`}
                value={value}
                autoComplete="off"
                required={isRequired}
                tabIndex="0"
              />
              <span
                style={{
                  fontSize: '16px',
                  fontFamily: globalSettings.normalText_fontFamily,
                  '--tw-ring-opacity': 1,
                  '--tw-ring-color': hexToRgba(
                    globalSettings.themeColor,
                    1
                  ).replace('1)', 'var(--tw-ring-opacity))'),
                }}
                className="border-gray-300"
              >
                {value}
              </span>
            </label>
          )
        })}
      </div>
      <div className="labels">
        <span
          style={{
            fontSize: `${inlineStyles.label.fontSize}`,
            fontFamily: globalSettings.normalText_fontFamily,
            color: globalSettings.normalText_color,
          }}
        >
          {startLabel}
        </span>
        <span
          style={{
            fontSize: `${inlineStyles.label.fontSize}`,
            fontFamily: globalSettings.normalText_fontFamily,
            color: globalSettings.normalText_color,
          }}
        >
          {endLabel}
        </span>
      </div>
      <div
        className="gan-validation-field-error"
        style={{
          color: 'red',
          fontSize: `${globalSettings.normalText_fontSize * 0.7}px`,
        }}
      />
    </div>
  )
}

Scale.propTypes = {
  model: PropTypes.instanceOf(ScaleModel),
  editor: PropTypes.instanceOf(EditorModel),
  app: PropTypes.instanceOf(AppModel),
  serverRender: PropTypes.bool,
}

export default inject('editor', 'serverRender', 'app')(observer(Scale))
